"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invite = exports.local = exports.stream = exports.room = exports.reach = void 0;

var _User = _interopRequireDefault(require("../core/User"));

var _Room = _interopRequireDefault(require("../core/Room"));

var _Invite = _interopRequireDefault(require("../core/Invite"));

var _Participant = _interopRequireDefault(require("../core/Participant"));

var _Message = _interopRequireDefault(require("../core/Message"));

var _Remote = _interopRequireDefault(require("../core/stream/Remote"));

var _constants = require("../core/util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The events supported by {@link Reach#on}
 * @typedef {Object} Events/Reach
 * @property {string} USER_ADDED Fired when a new user is registered
 * @property {string} USER_CHANGED Fired when an existing user logs in or out or changes is status
 * @property {string} USER_REMOVED Fired when a user is unregistered
 * @property {string} ROOM_ADDED Fired when a room is created
 * @property {string} ROOM_CHANGED Fired when a room status is changing
 * @property {string} ROOM_REMOVED Fired when a room is closed definitely
 * @property {string} INVITE_ADDED Fired when an invite is received
 * @property {string} INVITE_CHANGED Fired when an invite status is modified
 */

/**
 * The events supported by {@link Room#on}
 * @typedef {Object} Events/Room
 * @property {string} PARTICIPANT_ADDED Fired when a new participant is added to the room.
 * Does not mean he's connected but that he's invited to
 * @property {string} PARTICIPANT_CHANGED Fired when a participant
 * changes is status (enter/leaves the room)
 * @property {string} PARTICIPANT_REMOVED Fired when a user leaves definitely or is banned
 * @property {string} MESSAGE_ADDED Fired when a new instant message is sent to the room
 * @property {string} MESSAGE_CHANGED Fired when an instant message is edited
 * @property {string} MESSAGE_REMOVED Fired when an instant message is removed
 * @property {string} STREAM_PUBLISHED Fired when a participant publishes a stream
 * @property {string} STREAM_UNPUBLISHED Fired when a participant stops the publishing of his stream
 */

/**
 * The events supported by {@link Invite#on}
 * @typedef {Object} Events/Invite
 * @property {string} ACCEPTED Fired when the invite has been accepted
 * @property {string} REJECTED Fired when the invite has been accepted
 * @property {string} CANCELED Fired when the invite has been canceled
 */

/**
 * The events supported by {@link Remote#on}.
 * @typedef {Object} Events/Stream
 * @property {string} MUTE Fired when the mute status of the stream changes
 * @property {string} SIZE Fired when the size of the stream changes
 * @property {string} WEBRTC_ERROR Fired when an error is raised on webrtc call.
 */

/**
 * The events supported by {@link Local#on}.
 * @typedef {Object} Events/Local
 * @property {string} SUBSCRIBED Fired when the is subcribed by remote
 * @property {string} WEBRTC_ERROR Fired when an error is raised on webrtc call.
 */

/**
 * Path configuration for each event
 * @ignore
 * @type {{}}
 */
var paths = {
  USER: function USER() {
    return 'users';
  },
  ROOM: function ROOM() {
    return 'rooms';
  },
  INVITE: function INVITE(user) {
    if (!user) {
      throw new Error('You must be authenticated to list the invites');
    }

    return "_/invites/".concat(user.uid);
  },
  PARTICIPANT: function PARTICIPANT(room) {
    return "_/rooms/".concat(room.uid, "/participants");
  },
  MESSAGE: function MESSAGE(room) {
    return "_/rooms/".concat(room.uid, "/messages");
  },
  STREAM: function STREAM(room) {
    return "_/rooms/".concat(room.uid, "/streams");
  }
};
/**
 * Object type configuration for each event
 * @ignore
 * @type {{}}
 */

var classes = {
  USER: _User.default,
  ROOM: _Room.default,
  INVITE: _Invite.default,
  PARTICIPANT: _Participant.default,
  MESSAGE: _Message.default,
  STREAM: _Remote.default
};
/**
 * Private class to add support test methods
 * @class _Events
 * @ignore
 */

var _Events =
/*#__PURE__*/
function () {
  function _Events(keys) {
    var _this = this;

    _classCallCheck(this, _Events);

    keys.forEach(function (key) {
      _this[key] = key;
    });
  }

  _createClass(_Events, [{
    key: "supports",
    value: function supports(event) {
      if (!event || typeof event !== 'string' || this[event] !== event.toUpperCase()) {
        throw new Error("Unsupported event. Use one of the following: ".concat(JSON.stringify(Object.keys(this))));
      }

      return true;
    }
  }, {
    key: "toPath",
    value: function toPath(event) {
      if (this.supports(event)) {
        return paths[event.toUpperCase().replace(/_.*$/, '')] || function () {
          return null;
        };
      }

      return null;
    }
  }, {
    key: "toClass",
    value: function toClass(event) {
      if (this.supports(event)) {
        return classes[event.toUpperCase().replace(/_.*$/, '')];
      }

      return null;
    }
  }]);

  return _Events;
}();
/**
 * @ignore
 */


var reach = new _Events(['USER_ADDED', 'USER_CHANGED', 'USER_REMOVED', 'ROOM_ADDED', 'ROOM_CHANGED', 'ROOM_REMOVED', 'INVITE_ADDED', 'INVITE_CHANGED']);
/**
 * @ignore
 */

exports.reach = reach;
var room = new _Events(['MESSAGE_ADDED', 'MESSAGE_CHANGED', 'MESSAGE_REMOVED', 'PARTICIPANT_ADDED', 'PARTICIPANT_CHANGED', 'PARTICIPANT_REMOVED', 'STREAM_PUBLISHED', 'STREAM_UNPUBLISHED']);
/**
 * @ignore
 */

exports.room = room;
var stream = new _Events(['MUTE', 'SIZE', 'WEBRTC_ERROR']);
/**
 * @ignore
 */

exports.stream = stream;
var local = new _Events(['SUBSCRIBED', 'WEBRTC_ERROR']);
/**
 * @ignore
 */

exports.local = local;
var invite = new _Events([_constants.ACCEPTED, _constants.REJECTED, _constants.CANCELED]);
exports.invite = invite;